// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"46f6708a","336":"3c6b30e1","429":"246f7dee","937":"8c249f4a"}[chunkId] + ".css";
};